<template>
  <b-row>
    <b-col
      lg="8"
      md="6"
    >
      <classmate-list />
    </b-col>
    <b-col
      lg="4"
      md="6"
    >
      <course-detail />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import ClassmateList from './components/classmates/ClassmateList.vue'
import CourseDetail from './components/classmates/CourseDetail.vue'

export default {
  components: {
    BRow,
    BCol,

    ClassmateList,
    CourseDetail,
  },
}
</script>
